<template>
  <v-container
    fluid
  >
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('search')"
        single-line
        hide-details
        class="mb-2"
      />
      <v-btn
        color="primary"
        class="ms-2"
        @click="newItem()"
      >
        <i class="fas fa-layer-plus fa-lg me-2" />
        {{ $t('new') }}
      </v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="dataRows"
      :items-per-page="tableCPP"
      :search="search"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn-toggle>
          <v-btn
            fab
            x-small
            class="light-green"
            @click="uploadImagesItem(item)"
          >
            <i
              class="fal fa-photo-video fa-lg"
            />
          </v-btn>
          <v-btn
            fab
            x-small
            class="blue"
            @click="showItem(item)"
          >
            <i
              class="fal fa-eye fa-lg"
            />
          </v-btn>
          <v-btn
            fab
            x-small
            class="warning"
            @click="editItem(item)"
          >
            <i
              class="fal fa-pencil fa-lg"
            />
          </v-btn>
          <v-btn
            fab
            x-small
            class="error"
            @click="deleteConfirm(item)"
          >
            <i
              class="fal fa-trash-alt fa-lg"
            />
          </v-btn>
        </v-btn-toggle>
      </template>
      <template v-slot:item.status_text="{ item }">
        <v-chip
          :color="getStatusColor(item.status_text)"
        >
          {{ $t(item.status_text) }}
        </v-chip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      :persistent="true"
      :internal-activator="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title>
          <span
            class="headline"
          >
            {{ formTitle }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="10"
              >
                <v-text-field
                  v-model="editedItem.title"
                  :label="$t('title')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="2"
              >
                <v-switch
                  v-model="editedItem.status"
                >
                  <template
                    v-slot:prepend
                  >
                    <span class="mt-1 me-2">{{ $t('status') }}</span>
                  </template>
                </v-switch>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  v-model="editedItem.category"
                  :label="$t('category')"
                  :items="categoryRows"
                  item-text="display"
                  item-value="dbitem"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.order"
                  :label="$t('order')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
              >
                <v-switch
                  v-model="editedItem.allow_comment"
                >
                  <template
                    v-slot:prepend
                  >
                    <span
                      class="mt-1 me-2 text-no-wrap"
                    >
                      {{ $t('allow_comment') }}
                    </span>
                  </template>
                </v-switch>
              </v-col>
              <v-col
                cols="12"
              >
                <span>{{ $t('description') }}</span>
                <ckeditor
                  v-model="editedItem.description"
                  :editor="editor"
                  :config="editorConfig"
                />
              </v-col>
            </v-row>
            <v-divider />
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-if="dynamicColumns.dynamic_column_01 !== ''"
                  v-model="editedItem.dynamic_column_01"
                  :label="dynamicColumns.dynamic_column_01"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-if="dynamicColumns.dynamic_column_02 !== ''"
                  v-model="editedItem.dynamic_column_02"
                  :label="dynamicColumns.dynamic_column_02"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-if="dynamicColumns.dynamic_column_03 !== ''"
                  v-model="editedItem.dynamic_column_03"
                  :label="dynamicColumns.dynamic_column_03"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-if="dynamicColumns.dynamic_column_04 !== ''"
                  v-model="editedItem.dynamic_column_04"
                  :label="dynamicColumns.dynamic_column_04"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-if="dynamicColumns.dynamic_column_05 !== ''"
                  v-model="editedItem.dynamic_column_05"
                  :label="dynamicColumns.dynamic_column_05"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-if="dynamicColumns.dynamic_column_06 !== ''"
                  v-model="editedItem.dynamic_column_06"
                  :label="dynamicColumns.dynamic_column_06"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-if="dynamicColumns.dynamic_column_07 !== ''"
                  v-model="editedItem.dynamic_column_07"
                  :label="dynamicColumns.dynamic_column_07"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-if="dynamicColumns.dynamic_column_08 !== ''"
                  v-model="editedItem.dynamic_column_08"
                  :label="dynamicColumns.dynamic_column_08"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-if="dynamicColumns.dynamic_column_09 !== ''"
                  v-model="editedItem.dynamic_column_09"
                  :label="dynamicColumns.dynamic_column_09"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-if="dynamicColumns.dynamic_column_10 !== ''"
                  v-model="editedItem.dynamic_column_10"
                  :label="dynamicColumns.dynamic_column_10"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :loading="btnLoadingSave"
            :disabled="btnLoadingSave"
            @click="save"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogShow"
      :persistent="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="4"
                sm="9"
                md="10"
              >
                <p>{{ $t('id') }} : <strong>{{ editedItem.id }}</strong></p>
              </v-col>
              <v-col
                cols="6"
                sm="3"
                md="2"
              >
                <v-switch
                  v-model="editedItem.status"
                  disabled
                >
                  <template
                    v-slot:prepend
                  >
                    <span class="mt-1 me-2 text-no-wrap">{{ $t('status') + ` : ` + $t(editedItem.status_text) }}</span>
                  </template>
                </v-switch>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('title') }} : <strong>{{ editedItem.title }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('order') }} : <strong>{{ editedItem.order }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('allow_comment') }} : <strong>{{ (editedItem.allow_comment ? $t('active') : $t('deactivate')) }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('category') }} : <strong>{{ editedItem.category_text }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('description') }} : </p>
                <ckeditor
                  v-model="editedItem.description"
                  :editor="editor"
                  :config="editorConfig"
                  :disabled="true"
                />
              </v-col>
            </v-row>
            <v-divider />
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('created_at') }} : <strong>{{ editedItem.created_at }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('updated_at') }} : <strong>{{ editedItem.updated_at }}</strong></p>
              </v-col>
            </v-row>
            <v-divider />
            <v-row>
              <v-col
                v-if="dynamicColumns.dynamic_column_01 !== ''"
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ dynamicColumns.dynamic_column_01 }} : <strong>{{ editedItem.dynamic_column_01 }}</strong></p>
              </v-col>
              <v-col
                v-if="dynamicColumns.dynamic_column_02 !== ''"
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ dynamicColumns.dynamic_column_02 }} : <strong>{{ editedItem.dynamic_column_02 }}</strong></p>
              </v-col>
              <v-col
                v-if="dynamicColumns.dynamic_column_03 !== ''"
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ dynamicColumns.dynamic_column_03 }} : <strong>{{ editedItem.dynamic_column_03 }}</strong></p>
              </v-col>
              <v-col
                v-if="dynamicColumns.dynamic_column_04 !== ''"
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ dynamicColumns.dynamic_column_04 }} : <strong>{{ editedItem.dynamic_column_04 }}</strong></p>
              </v-col>
              <v-col
                v-if="dynamicColumns.dynamic_column_05 !== ''"
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ dynamicColumns.dynamic_column_05 }} : <strong>{{ editedItem.dynamic_column_05 }}</strong></p>
              </v-col>
              <v-col
                v-if="dynamicColumns.dynamic_column_06 !== ''"
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ dynamicColumns.dynamic_column_06 }} : <strong>{{ editedItem.dynamic_column_06 }}</strong></p>
              </v-col>
              <v-col
                v-if="dynamicColumns.dynamic_column_07 !== ''"
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ dynamicColumns.dynamic_column_07 }} : <strong>{{ editedItem.dynamic_column_07 }}</strong></p>
              </v-col>
              <v-col
                v-if="dynamicColumns.dynamic_column_08 !== ''"
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ dynamicColumns.dynamic_column_08 }} : <strong>{{ editedItem.dynamic_column_08 }}</strong></p>
              </v-col>
              <v-col
                v-if="dynamicColumns.dynamic_column_09 !== ''"
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ dynamicColumns.dynamic_column_09 }} : <strong>{{ editedItem.dynamic_column_09 }}</strong></p>
              </v-col>
              <v-col
                v-if="dynamicColumns.dynamic_column_10 !== ''"
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ dynamicColumns.dynamic_column_10 }} : <strong>{{ editedItem.dynamic_column_10 }}</strong></p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogImages"
      :persistent="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-file-input
                v-model="files"
                counter
                :label="$t('select_files')"
                multiple
                prepend-icon="mdi-paperclip"
                accept="image/*"
                outlined
                dense
                :show-size="1000"
                class="me-4"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                    v-if="index < 3"
                    label
                    small
                  >
                    {{ text }}
                  </v-chip>
                  <v-chip
                    v-else-if="index === 3"
                    label
                    small
                  >
                    +{{ files.length - 3 }}
                  </v-chip>
                </template>
              </v-file-input>
              <v-btn
                depressed
                class="me-2 blue"
                :loading="btnLoadingUpload"
                :disabled="btnLoadingUpload"
                @click="upload()"
              >
                <i
                  class="fad fa-upload fa-lg"
                />
              </v-btn>
            </v-row>
            <v-divider />
            <v-row>
              <v-col cols="12">
                <v-container fluid>
                  <v-row>
                    <v-col
                      v-for="image in imageFiles"
                      :key="image"
                      class="d-flex child-flex"
                      cols="2"
                    >
                      <v-hover
                        open-delay="1000"
                        v-slot:default="{ hover }"
                      >
                        <v-card
                          flat
                          tile
                          class="d-flex"
                        >
                          <v-img
                            :src="image.file"
                            :lazy-src="image.file"
                            aspect-ratio="1"
                            class="grey lighten-2"
                          >
                            <v-expand-transition>
                              <div
                                v-if="hover"
                                class="d-flex transition-fast-in-fast-out grey darken-4 v-card--reveal py-3"
                              >
                                <v-btn
                                  small
                                  color="red"
                                  @click="deleteImage(image.id)"
                                >
                                  {{ $t('delete') }}
                                </v-btn>
                              </div>
                            </v-expand-transition>
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                />
                              </v-row>
                            </template>
                          </v-img>
                        </v-card>
                      </v-hover>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-bottom-sheet
        v-model="deleteSheet"
        persistent
        inset
      >
        <v-sheet
          class="text-center"
          height="200px"
        >
          <v-btn
            class="mt-6"
            color="error"
            :loading="btnLoadingDelete"
            :disabled="btnLoadingDelete"
            @click="deleteItem(editedItem)"
          >
            {{ $t('delete') }}
          </v-btn>
          <v-btn
            class="mt-6 ms-2"
            color="green"
            @click="deleteSheet = !deleteSheet"
          >
            {{ $t('close') }}
          </v-btn>
          <div class="py-3">
            {{ $t('permanently_delete?') }} {{ $t('you_can_not_undo.') }}
            <p class="pt-3">
              {{ $t('id') }} : <strong>{{ editedItem.id }}</strong> ,
              {{ $t('title') }} : <strong>{{ editedItem.title }}</strong>
            </p>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="6000"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          tile
          small
          outlined
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  export default {
    name: 'Operations',
    data () {
      return {
        headers: [],
        dataRows: [],
        categoryRows: [],
        dynamicColumns: [],
        uploadRules: [
          value => !value || value.size < 2000000 || this.$t('file_size_should_be_less_than_2_mb!'),
        ],
        tableCPP: 0,
        search: '',
        loading: true,
        dialog: false,
        dialogShow: false,
        dialogImages: false,
        editedIndex: -1,
        editedItem: {},
        defaultItem: {},
        formTitle: '',
        deleteSheet: false,
        btnLoadingDelete: false,
        btnLoadingSave: false,
        btnLoadingUpload: false,
        snackbar: false,
        snackbarColor: '', // ['success', 'info', 'error', 'cyan darken-2']
        snackbarText: '',
        editor: ClassicEditor,
        editorConfig: {
          language: {
            ui: 'en',
            content: 'fa',
          },
          toolbar: [
            'undo',
            'redo',
            'fontColor',
            'fontBackgroundColor',
            'fontSize',
            '|',
            'bold',
            'italic',
            'underline',
            'removeFormat',
            'alignment',
            'bulletedList',
            'numberedList',
            'horizontalLine',
            '|',
            'link',
            'imageUpload',
            'insertTable',
            'mediaEmbed',
          ],
          image: {
            toolbar: [
              'imageTextAlternative',
              'imageStyle:full',
              'imageStyle:side',
            ],
          },
          table: {
            contentToolbar: [
              'tableColumn',
              'tableRow',
              'mergeTableCells',
            ],
          },
        },
        files: [],
        imageFiles: [],
      }
    },
    async created () {
      await this.getCategoryData()
      await this.getData()
      await this.getOptions()
      await this.getDynamicColumns()
    },
    methods: {
      getOptions () {
        this.$http.post('options/showByTitle', {
          title: 'Blog-CPP',
        }).then(
          response => {
            const result = response.data.Option
            this.tableCPP = parseInt(result.value)
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': options/showByTitle|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showByTitle|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getHeaders () {
        this.$http.post('options/showTableHeader', {
          title: 'Blog-TH-Operations',
        }).then(
          response => {
            const result = response.data.Option
            this.headers = []
            this.headers.push({ text: this.$t('id'), value: 'id' })
            result.forEach(o => {
              this.headers.push({
                text: this.$t((typeof this.dynamicColumns[o.value] !== 'undefined') ? this.dynamicColumns[o.value] : o.value),
                value: o.value,
              })
            })
            this.headers.push({ text: this.$t('actions'), value: 'actions', sortable: false })
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': options/showTableHeader|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showTableHeader|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getDynamicColumns () {
        this.$http.post('dynamicColumns/showByTable', {
          table: 'blog',
        }).then(
          response => {
            const result = response.data.DynamicColumns
            result.forEach(o => {
              this.dynamicColumns[o.column] = this.$t(o.title)
            })
            this.getHeaders()
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': dynamicColumns/showByTable|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': dynamicColumns/showByTable|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getData () {
        this.$http.post('blog/index').then(
          response => {
            this.dataRows = response.data.Blog
            this.editedItem = Object.assign({}, this.dataRows[0])
            const tempArray = []
            Object.keys(this.editedItem).forEach(function (item) {
              Object.assign(tempArray, { [item]: null })
            })
            this.defaultItem = tempArray
            this.loading = false
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': blog/index|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': blog/index|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getCategoryData () {
        this.$http.post('blog/categoriesIndex').then(
          response => {
            this.categoryRows = response.data.BlogCategories
            const tempArray = []
            this.categoryRows.forEach(function (value) {
              tempArray.push({ dbitem: value.id, display: value.title })
            })
            this.categoryRows = tempArray
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': blogCategories/index|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': blogCategories/index|902'
          this.snackbar = true
          console.log(error)
        })
      },
      newItem () {
        this.formTitle = this.$t('new')
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.dialog = true
      },
      editItem (item) {
        this.formTitle = this.$t('edit')
        this.editedIndex = this.dataRows.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      uploadImagesItem (item) {
        this.imageFiles = []
        this.editedIndex = this.dataRows.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogImages = true
        this.$http.post('blog/showImages', {
          blogId: this.editedItem.id,
        }).then(response => {
          this.imageFiles = response.data.BlogImages
        }, error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x931'
            this.snackbar = true
          }
        }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x932'
            this.snackbar = true
          }
        })
      },
      deleteImage (imageID) {
        this.$http.post('blog/destroyImage', {
          id: imageID,
        }).then(
          response => {
            const index = this.imageFiles.indexOf(this.imageFiles.find(x => x.id === imageID))
            this.imageFiles.splice(index, 1)
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_deleted')
            this.snackbar = true
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': blog/delete|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': blog/delete|902'
          this.snackbar = true
          console.log(error)
        })
      },
      deleteConfirm (item) {
        this.editedItem = Object.assign({}, item)
        this.deleteSheet = true
      },
      showItem (item) {
        this.editedItem = Object.assign({}, item)
        this.dialogShow = true
      },
      deleteItem (item) {
        this.btnLoadingDelete = true
        this.$http.post('blog/delete', {
          id: item.id,
        }).then(
          response => {
            const index = this.dataRows.indexOf(this.dataRows.find(x => x.id === item.id))
            this.dataRows.splice(index, 1)
            this.deleteSheet = false
            this.btnLoadingDelete = false
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_deleted')
            this.snackbar = true
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': blog/delete|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': blog/delete|902'
          this.snackbar = true
          console.log(error)
        })
      },
      save () {
        this.btnLoadingSave = true
        if (this.editedIndex > -1) {
          this.$http.post('blog/update', this.editedItem).then(
            response => {
              Object.assign(this.dataRows[this.editedIndex], this.editedItem)
              this.btnLoadingSave = false
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_updated')
              this.snackbar = true
              this.close()
            },
            error => {
              if (error.data.code === 2001) {
                this.$router.push('/login')
              } else {
                this.btnLoadingSave = false
                this.snackbarColor = 'error'
                this.snackbarText = this.$t('server_error') + ': blog/update|901'
                this.snackbar = true
              }
            }).catch(error => {
            this.btnLoadingSave = false
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': blog/update|902'
            this.snackbar = true
            console.log(error)
          })
        } else {
          this.editedItem.language_id = 1
          this.$http.post('blog/create', this.editedItem).then(
            response => {
              this.dataRows.push(response.data.Blog)
              this.btnLoadingSave = false
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_inserted')
              this.snackbar = true
              this.close()
            },
            error => {
              if (error.data.code === 2001) {
                this.$router.push('/login')
              } else {
                this.btnLoadingSave = false
                this.snackbarColor = 'error'
                this.snackbarText = this.$t('server_error') + ': blog/create|901'
                this.snackbar = true
              }
            }).catch(error => {
            this.btnLoadingSave = false
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': blog/create|902'
            this.snackbar = true
            console.log(error)
          })
        }
      },
      close () {
        this.dialog = false
        this.dialogShow = false
        this.dialogImages = false
        this.files = []
        this.editedIndex = -1
      },
      upload () {
        const formData = new FormData()
        this.btnLoadingUpload = true
        this.files.forEach(function (value, index) {
          formData.append('file' + index, value)
        })
        formData.append('blogId', this.editedItem.id)
        formData.append('fileCount', this.files.length)
        this.$http.post('blog/uploadImage', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        }).then(response => {
          this.imageFiles = response.data.BlogImages
          this.files = []
          this.btnLoadingUpload = false
        }, error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x933'
            this.snackbar = true
            this.btnLoadingUpload = false
          }
        }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x934'
            this.snackbar = true
            this.btnLoadingUpload = false
          }
        })
      },
      getStatusColor (text) {
        let returnColor
        switch (text) {
          case 'deactivate':
            returnColor = 'red'
            break
          case 'active':
            returnColor = 'green'
            break
          case 'locked':
            returnColor = 'purple'
            break
          case 'unknown':
            returnColor = 'yellow'
            break
          default:
            returnColor = 'yellow'
        }
        return returnColor
      },
    },
  }
</script>

<style scoped>

</style>
